import { render, staticRenderFns } from "./AddRouter.vue?vue&type=template&id=532f48da&scoped=true&"
import script from "./AddRouter.vue?vue&type=script&lang=js&"
export * from "./AddRouter.vue?vue&type=script&lang=js&"
import style0 from "./AddRouter.vue?vue&type=style&index=0&id=532f48da&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "532f48da",
  null
  
)

export default component.exports